import { gql } from '@apollo/client';

export const TextNotification = gql`
    mutation textNotification($active: Boolean!, $phoneNumber: String!, $agentId: ID!) {
        textNotification(active: $active, phoneNumber: $phoneNumber, agentId: $agentId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
